import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import React from 'react';
import Formatter from '../../../formatter';
import getFileThumbnailPath from '../../../utils/pathUtil/getFileThumbnailPath';
import getRepositoryItemName from '../../../utils/pathUtil/getRepositoryItemName';
import cleanPath from '../../../utils/pathUtil/cleanPath';
import encodePathForUriComponent from '../../../utils/pathUtil/encodePathForUriComponent';
/**@type {import('../types').DataType<RepositoryModel>} */

var REPOSITORY_DATA_TYPE = {
  data: {
    dataKey: 'repository',
    idKeyProp: 'Path',
    url: '/backend/repository?workspace={workspace}&path={path}',
    ///  -> api/v2/folders/lookup?workspace={workspace}&path={path}&recursive=false
    createItemUrl: function createItemUrl(config, requestAction, item) {
      if (config && config.dataProps && config.dataProps.type === 'folder') {
        return '/backend/folders';
      } else if (config && config.dataProps && config.dataProps.type === 'file') {
        return {
          url: "/backend/upload?workspace=".concat(encodeURIComponent(item.workspace), "&folderPath=").concat(item.folderPath, "&optimizeImageWeb=").concat(item.optimizeImageWeb || false, "&widthHeightMaxLimit=").concat(item.widthHeightMaxLimit || -1),
          attach: item.files,
          data: null,
          auth: 'field',
          fields: [{
            name: 'hasVersions',
            value: 'auto' // preserve old value

          }]
        };
      }

      throw new Error('repo type not supported');
    },
    itemUrl: null,
    deleteItemUrl: function deleteItemUrl(config, request, item) {
      var workspaceParam = encodeURIComponent(item.Workspace);
      var pathParam = encodePathForUriComponent(item.Path);
      if (item.ItemType === 'folder') return "/backend/folders?workspace=".concat(workspaceParam, "&path=").concat(pathParam);else if (item.ItemType === 'file') return "/backend/files?workspace=".concat(workspaceParam, "&path=").concat(pathParam);else throw new Error('repo type not yet supported');
    },
    renameItemUrl: function renameItemUrl(config, request, item, dataTypeConfig, newName) {
      var url = '';
      if (item.ItemType === 'folder') url = '/backend/folders';else if (item.ItemType === 'file') url = '/backend/files';else throw new Error('repo type not yet supported');
      var OldPath = cleanPath(item.Path);
      var segments = OldPath.split('/');
      segments.pop();
      var NewPath = segments.join('/') + '/' + newName;
      return {
        url: url,
        data: {
          Action: 'rename',
          NewPath: NewPath,
          OldPath: OldPath,
          Workspace: item.Workspace
        }
      };
    },
    onBeforeRequest: function onBeforeRequest(config, request) {
      if (!config.dataProps) return;
      if (request.type !== 'loadView') return;
      var _config$dataProps = config.dataProps,
          workspace = _config$dataProps.workspace,
          path = _config$dataProps.path,
          filter = _config$dataProps.filter;
      var url = request.url;
      url = url.split('{workspace}').join(workspace).split('{path}').join(path);

      if (filter) {
        var filterVal = '';
        if (filter.extensions) filterVal = filter.extensions.join(',');
        if (filterVal) url = url + '&ExtFilter=' + filterVal;
        filterVal = '';
        if (filter.onlyFolders) filterVal = 'folders';
        if (filterVal) url = url + '&TypeFilter=' + filterVal;
      }

      return {
        url: url
      };
    },
    onAfterResponse: function onAfterResponse(options, request, body) {
      if (request.type === 'loadView') {
        return {
          Data: body.Data.map(function (i) {
            return _objectSpread({}, i, {
              Path: cleanPath(i.Path)
            });
          })
        };
      }
    }
  },
  placeholders: {
    type: function type(data) {
      return !data ? '' : data.ItemType === 'folder' ? 'folder' : 'file';
    },
    label: function label(data) {
      return !data ? '' : getRepositoryItemName(data.Path);
    },
    icon: function icon(data) {
      return !data ? '' : data.ItemType === 'folder' ? 'folder' : 'file';
    }
  },
  columns: [{
    id: 'Name',
    children: 'Name',
    formatter: function formatter(_ref) {
      var data = _ref.data;
      return React.createElement(Formatter.Link, {
        icon: {
          path: data.Path
        },
        text: getRepositoryItemName(data.Path),
        color: "inherit",
        to: ""
      });
    },
    serverSort: true,
    width: {
      xs: '50%'
    }
  }, {
    id: 'Type',
    children: 'Type',
    formatter: function formatter(_ref2) {
      var data = _ref2.data;
      return React.createElement(Formatter.Text, {
        value: data.Type || 'Folder'
      });
    },
    width: {
      xs: 0,
      md: 'auto'
    }
  }, {
    id: 'Size',
    children: 'Size',
    formatter: function formatter(_ref3) {
      var data = _ref3.data;
      return React.createElement(Formatter.Text, {
        value: data.Length
      });
    },
    serverSort: true
  }, {
    id: 'DateModified',
    children: 'Last Modified',
    formatter: function formatter(_ref4) {
      var data = _ref4.data;
      return React.createElement(Formatter.DateTime, {
        value: data.DateModified,
        variant: "short"
      });
    },
    serverSort: true
  }],
  thumbnail: {
    url: function url(data) {
      return getFileThumbnailPath({
        path: data.Path,
        workspace: data.Workspace,
        token: data.ResourceToken
      });
    },
    text: function text(data) {
      return getRepositoryItemName(data.Path);
    },
    icon: function icon(data) {
      return {
        path: data.Path
      };
    },
    style: function style(data) {
      if (data.ItemType === 'folder') return {
        maxWidth: '8em',
        maxHeight: '8em'
      };
      return {};
    }
  },
  contextMenu: [{
    type: 'open'
  }, {
    type: 'rename',
    modalProps: function modalProps(data) {
      return {
        windowProps: {
          doNotCapitalizeHeader: true
        },
        formField: {
          type: data.ItemType === 'folder' ? 'folderName' : 'fileName'
        }
      };
    }
  }, 'separator', {
    type: 'delete'
  }]
};
export default REPOSITORY_DATA_TYPE;